import { computed, reactive, ref, type ComputedRef } from 'vue'
import { ElMessage } from 'element-plus'
import { alarmCategories, allAlarmTypes, categoryAlarms, createStationAlarmsMap } from './constants'
import type { CatKey, StationRow } from './types'

/**
 * 电站告警开关（运营）：单选电站，逐项开关其告警类型。
 * @param stations 全部电站列表，由上层注入以保证单例共享。
 */
export function useStationAlarms(stations: ComputedRef<StationRow[]>) {
  const stationSearch = ref('')
  const selectedStation = ref<StationRow | null>(null)
  const curAlarms = reactive<Record<string, boolean>>({})

  const stationAlarmsMap: Record<string, Record<string, boolean>> = createStationAlarmsMap()

  const filteredStations = computed(() =>
    stationSearch.value ? stations.value.filter((s) => s.name.includes(stationSearch.value)) : stations.value,
  )

  function selectStation(s: StationRow) {
    if (selectedStation.value) {
      stationAlarmsMap[selectedStation.value.id] = { ...curAlarms }
    }
    selectedStation.value = s
    const m = stationAlarmsMap[s.id]
    allAlarmTypes.forEach((a) => {
      curAlarms[a.code] = m ? !!m[a.code] : true
    })
  }

  function enabledCount(s: StationRow) {
    const m = stationAlarmsMap[s.id]
    return m ? Object.values(m).filter(Boolean).length : allAlarmTypes.length
  }

  function catEnabledCount(k: CatKey) {
    return categoryAlarms(k).filter((a) => curAlarms[a.code]).length
  }

  function toggleAll(v: boolean) {
    allAlarmTypes.forEach((a) => {
      curAlarms[a.code] = v
    })
  }

  // 把当前编辑中的电站开关写回 map（保存前调用）
  function flushSelected() {
    if (selectedStation.value) {
      stationAlarmsMap[selectedStation.value.id] = { ...curAlarms }
    }
  }

  function saveStationConfig() {
    if (!selectedStation.value) return
    flushSelected()
    ElMessage.success(`「${selectedStation.value.name}」配置已保存`)
  }

  return {
    alarmCategories,
    allAlarmTypes,
    categoryAlarms,
    stationSearch,
    selectedStation,
    curAlarms,
    stationAlarmsMap,
    filteredStations,
    selectStation,
    enabledCount,
    catEnabledCount,
    toggleAll,
    flushSelected,
    saveStationConfig,
  }
}
